import {Controller} from "@hotwired/stimulus";
import {useModal} from "../js/stimulus_use/use-modal";
import $ from "jquery";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'share',
        'litigant--choose-or-create',
    ];

    static values = {
        litigantName: String,
        litigantId: Number,
        source: String,
        isViewed: Boolean,
        isGuideShown: Boolean,
    };

    static targets = [
        'litigantNameInput',
        'litigantName',
        'guide',
        'dontShowInput',
        'litigant',
        'form',
        'messageInput',
        'invalidMessage',
        'urlInput',
    ];

    dontShowAgainUrl = routes['app_onlineconsultation_onlineconsultationguidepopupdontshow'];
    viewedUrl = routes['app_onlineconsultation_setonlineconsultationmodalasviewedat'];
    litigantName = '';

    connect() {
        useModal(this, {
            withGuide: true,
            withViewed: true,
            withLitigant: true,
        });
    }

    onOpen() {
        this.clearForm()
        this.showLitigantOrForm();
    }

    onHide() {
        this.hideForm();
        this.hideLitigant();
        this.clearForm();
    }

    showLitigantOrForm() {
        if (this.litigantIdValue) {
            this.showForm();
            this.hideLitigant();
        } else {
            this.hideForm();
            this.showLitigant();
        }
    }

    litigantChosenOrCreated() {
        this.hideLitigant();
        this.showForm();
    }

    inputFieldEditToggle() {
        if (this.litigantNameInputTarget.disabled === true) {
            this.litigantNameInputTarget.disabled = false;
        } else {
            this.litigantNameInputTarget.disabled = true;
        }
    }

    showForm() {
        if (this.litigantChooseOrCreateOutlet.getName() !== null) {
            $(this.litigantNameTarget).text(this.litigantChooseOrCreateOutlet.getName());
        } else {
            $(this.litigantNameTarget).text(this.litigantNameValue);
        }

        this.formTarget.style.removeProperty('display');
    }

    hideForm(event) {
        event && event.preventDefault();

        this.formTarget.style.setProperty('display', 'none');
    }

    clearForm(event) {
        event && event.preventDefault();

        this.clearFormErrors();
        this.litigantChooseOrCreateOutlet.clear();
        this.messageInputTarget.value = '';
    }

    clearFormErrors() {
        this.litigantChooseOrCreateOutlet.clearErrors();
        this.invalidMessageTarget.style.setProperty('display', 'none');
        this.formTarget.querySelectorAll('.is-invalid').forEach((element) => {
            element.classList.remove('is-invalid');
        });
    }

    messageOnChange() {
        if (this.messageInputTarget.value) {
            this.messageInputTarget.classList.remove('is-invalid');
            this.invalidMessageTarget.style.setProperty('display', 'none');
        } else {
            this.messageInputTarget.classList.add('is-invalid');
            this.invalidMessageTarget.style.removeProperty('display');
        }
    }

    submitForm(event) {
        event && event.preventDefault();
        this.clearFormErrors();
        showPreloader();

        const formData = new FormData();
        formData.append('source', this.sourceValue);
        formData.append('message', this.messageInputTarget.value);

        if (!this.messageInputTarget.value) {
            this.messageInputTarget.classList.add('is-invalid');
            this.invalidMessageTarget.style.removeProperty('display');
            hidePreloader();
            return;
        }

        if (this.litigantIdValue) {
            formData.append('litigant_id', this.litigantIdValue)
        } else {
            const litigantData = this.litigantChooseOrCreateOutlet.getData();

            // foreach property of litigant data add to form data
            for (const [key, value] of Object.entries(litigantData)) {
                formData.append(key, value);
            }
        }

        $.ajax({
            url: routes['app_onlineconsultation_create'],
            data: formData,
            type: 'post',
            contentType: false,
            processData: false,
            success: (response) => {
                if (!response.status) {
                    addAlert('danger', response.message || translations['profile.An unknown error occurred.']);
                }

                if (window.location.href === response.chat_url) {
                    location.reload()
                } else {
                    window.location.href = response.chat_url;
                }
            }
        }).fail(() => {
            hidePreloader();
            addAlert('danger', translations['profile.An unknown error occurred.']);
        });
    }
}
